import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfTopHeaderComponent } from '../pdf-top-header/pdf-top-header.component';
import { PdfStatisticsCardComponent } from '../pdf-statistics-card/pdf-statistics-card.component';
import {
  StatisticsCardData,
  StatisticsCardFilter,
  StatisticsCardFilterWithGenderCount,
  StatisticsFilterForm,
} from 'src/app/shared/interfaces';
import { StatisticsCardComponent } from '../../statistics-card/statistics-card.component';
import {
  WhiteLabelPdfGendersStatistics,
  WhiteLabelTotalSessions,
  WhiteLabelUsersCommentsWithRate,
} from 'src/app/core/data/model';
import { CommentsListComponent } from '../../comments-list/comments-list.component';
import { MapSectionComponent } from '../../map-section/map-section.component';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { WhiteLabelChartFilterActions } from 'src/app/core/common';

@Component({
  selector: 'app-pdf-page',
  standalone: true,
  imports: [
    CommonModule,
    PdfTopHeaderComponent,
    PdfStatisticsCardComponent,
    StatisticsCardComponent,
    CommentsListComponent,
  ],
  templateUrl: './pdf-page.component.html',
  styleUrls: ['./pdf-page.component.scss'],
})
export class PdfPageComponent extends BaseComponent implements OnInit, OnChanges {
  statisticsCard: StatisticsCardFilterWithGenderCount[] = [];
  @Input() statisticsData: StatisticsCardData[] = [];
  @Input() filter: StatisticsFilterForm;
  @Input() cardsData: WhiteLabelTotalSessions;
  @Input() statisticsGenders: WhiteLabelPdfGendersStatistics;
  constructor(injector: Injector) {
    super(['WHITE_LABEL_DASHBOARD'], injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['cardsData']) {
      this.setStatisticsCardData();
    }
    if (changes && changes['statisticsGenders']) {
      this.setStatisticsCardData();
    }
  }

  ngOnInit(): void {}

  // privates
  private setStatisticsCardData(): void {
    this.statisticsCard = [
      {
        label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_CLIENTS'],
        statistics: this.cardsData?.benficiaryData.total ?? 0,
        statisticsPercentage: this.cardsData?.benficiaryData.rate ?? 0,
        cardAction: WhiteLabelChartFilterActions.BENEFICIARIES,
        male: this.statisticsGenders?.beneficiaries?.male || 0,
        female: this.statisticsGenders?.beneficiaries?.female || 0,
        total: this.statisticsGenders?.beneficiaries?.total || 1,
      },
      {
        label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_SESSIONS'],
        statistics: this.cardsData?.sessionData.total || 0,
        statisticsPercentage: this.cardsData?.sessionData.rate || 0,
        cardAction: WhiteLabelChartFilterActions.SESSIONS,
        male: this.statisticsGenders?.sessions?.male || 0,
        female: this.statisticsGenders?.sessions?.female || 0,
        total: this.statisticsGenders?.sessions?.total || 1,
      },
      // {
      //   label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_LETTERS'],
      //   statistics: this.cardsData?.lettersData.total || 0,
      //   statisticsPercentage: this.cardsData?.lettersData.rate || 0,
      //   cardAction: WhiteLabelChartFilterActions.LETTERS,
      //   male: this.statisticsGenders?.letters?.male || 0,
      //   female: this.statisticsGenders?.letters?.female || 0,
      //   total: this.statisticsGenders?.letters?.total || 1,
      // },
      // {
      //   label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_MINUTES'],
      //   statistics: this.cardsData?.minutesData.total || 0,
      //   statisticsPercentage: this.cardsData?.minutesData.rate || 0,
      //   cardAction: WhiteLabelChartFilterActions.MINUTES,
      //   male: this.statisticsGenders?.minutes?.male || 0,
      //   female: this.statisticsGenders?.minutes?.female || 0,
      //   total: this.statisticsGenders?.minutes?.total || 1,
      // },
      // {
      //   label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_FACES'],
      //   statistics: this.cardsData?.pagesData.total || 0,
      //   statisticsPercentage: this.cardsData?.pagesData.rate || 0,
      //   cardAction: WhiteLabelChartFilterActions.PAGES,
      //   male: this.statisticsGenders?.pages?.male || 0,
      //   female: this.statisticsGenders?.pages?.female || 0,
      //   total: this.statisticsGenders?.pages?.total || 1,
      // },
    ];
  }
}
